import { InformationCircleIcon } from "@heroicons/react/16/solid";
import clsx from "clsx";
import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

export function Tooltip({
  content,
  size,
  iconClassName,
  popoverClassName,
  color,
  placement = "top",
}) {
  const triggerRef = useRef();
  const [isHovered, setIsHovered] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  const updatePosition = () => {
    const rect = triggerRef?.current?.getBoundingClientRect();
    if (!rect) {
      return;
    }
    setPosition({
      top:
        placement === "bottom"
          ? rect.top + window.scrollY
          : rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
    });
  };

  useEffect(() => {
    updatePosition();
  }, [triggerRef, isHovered]);

  useEffect(() => {
    updatePosition();

    const handleScrollOrResize = () => {
      updatePosition();
    };

    window.addEventListener("scroll", handleScrollOrResize, true);
    window.addEventListener("resize", handleScrollOrResize);

    return () => {
      window.removeEventListener("scroll", handleScrollOrResize, true);
      window.removeEventListener("resize", handleScrollOrResize);
    };
  }, [content]);

  return (
    content && (
      <div
        className={clsx(
          `relative h-${size || 6} w-${size || 6}`,
          iconClassName,
        )}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <InformationCircleIcon
          ref={triggerRef}
          className={`h-${size || 6} w-${size || 6} mr-1 ${
            color ? `text-${color}` : ""
          }`}
        />

        {isHovered &&
          createPortal(
            <div
              className="h-5 w-5 absolute"
              style={{ ...position, zIndex: 9999999999 }}
            >
              <div
                className={clsx(
                  "w-[200px] -right-[20px] absolute bg-white rounded-[20px] border border-slate-200 flex justify-center flex-col-reverse items-center p-3",
                  placement === "bottom"
                    ? "top-[20px] shadow-md shadow-gray-200"
                    : "bottom-[54px] shadow-md shadow-gray-200",
                  popoverClassName,
                )}
                style={{ borderWidth: "0.5px" }}
              >
                <div>{content}</div>
              </div>

              {placement !== "bottom" && (
                <svg
                  className="absolute left-[1px] bottom-[35px]"
                  style={{
                    filter: "drop-shadow(0px 7px 5px rgba(100, 100, 100, 0.2))",
                  }}
                  width="20"
                  height="20"
                >
                  <polygon
                    points="0,-2 15,-2 7.5,15"
                    fill="white"
                    stroke="#e2e8f0"
                    strokeWidth="1"
                  />
                </svg>
              )}
            </div>,
            document.querySelector("body"),
          )}
      </div>
    )
  );
}
